<div class="confirm-payment-container d-flex flex-column gap-4">
  <button type="button" class="btn btn-primary home-btn" (click)="navigateHome()">
    <i class="fa-solid fa-house me-2"></i>Home
  </button>

  <div class="payment-container card p-4 " >
    <h1 class="title">Frequently Asked Questions</h1>

    <div class="faq">
      <h2><span class="number">1.</span>When will the online payment portal be launched?</h2>
      <p>It will be launched on <strong>1 September 2025</strong>.</p>
      <p>Court users can pay bail sums, court fees, court fines and court deposits* through the online Payment Portal, accessible from the SG Courts website.</p>
      <p><em>*Court deposits include payment for:</em></p>
      <ul>
        <li>Sheriff and/or Bailiff related services offered by the Courts;</li>
        <li>Proceedings under the Singapore International Commercial Court;</li>
        <li>Service-In of Documents from Foreign Jurisdiction to Singapore Courts</li>
        <li>Other case-specific court deposits</li>
      </ul>
    </div>

    <div class="faq">
      <h2><span class="number">2.</span>How will the launch of the online payment portal affect my current payment options?</h2>
      <p>You can continue to make online payments via PayNow or visit the courts for physical payments, if required.</p>
      <p>With the payment portal, you have another channel to make online payment via Credit/Debit Card or PayNow by scanning the QR code provided on your Payment Advice Chit (PAC)/ Invoice issued by the Courts without being physically present in Court premises.</p>
      <p>For Deposits where no PAC/Invoice had been issued by the Courts, you can also pay online via the payment portal using PayNow QR code (or PayNow UEN) or credit/debit card anytime , anywhere.</p>
      <p>As the SG Courts moves towards cashless payments, we encourage court users to make payment online through PayNow using your banking application or through the payment portal by scanning the QR code provided on your PAC/Invoice, where applicable.</p>
    </div>

    <div class="faq">
      <h2><span class="number">3.</span>What payment modes are available on the online payment portal?</h2>
      <p>Payment modes by PayNow and credit/debit card are available.</p>
      <p>For payment from overseas, you can also make payment in SGD using your overseas-issued credit/debit card.</p>
      <p>For payment via cheque or cashier’s order, you can deposit the cheque/ cashier’s order at the physical terminal in State Courts, Level 4.</p>
    </div>

    <div class="faq">
      <h2><span class="number">4.</span>How is the online payment portal different from the current payment modes available from the physical kiosks?</h2>
      <p>It is an online payment portal which is accessible via the internet. Hence, users need not be physically present in Court premises to make payment.</p>
      <p>As an online payment portal, it supports online payment modes (PayNow and credit/debit cards) but does not support payment modes which require a physical collection device (like NETS).</p>
      <p>For NETS or cash payments, court users can continue to use the existing payment kiosks in State Courts or approach the cashiers located at Supreme Court and FJC for payment till 30 Sep 2025.</p>
      <p>From 1 October 2025 onwards, for physical payments, please visit cashier counter at State Court Level 4 and Supreme Court Service Hub at Level 1.</p>
    </div>

    <div class="faq">
      <h2><span class="number">5.</span>What are the alternatives for court users who are not savvy with online payments to pay fines/ bail?</h2>
      <p>Court users who have no PayNow or access to internet or only able to pay via cash/cheque may do so at the cashier counter located at State Courts Level 4 and Supreme Court Service Hub at Level 1 available during Court operating hours.</p>
    </div>

    <div class="faq">
      <h2><span class="number">6.</span>If a court user faces an issue when using the online payment portal, whom may they contact for assistance?</h2>
      <p>Court users may contact us for assistance:</p>
      <ul>
        <li>Contact us via email <a href="mailto:contact&#64;judiciary.gov.sg">contact&#64;judiciary.gov.sg</a> or call 1800 587 8423.</li>
        <li>Visit cashier counter located at Supreme Court Service Hub at Level 1.</li>
        <li>Visit cashier counter located at State Court Level 4.</li>
      </ul>
    </div>

    <div class="faq">
      <h2><span class="number">7.</span>Will cashier’s order or cheque remain an acceptable payment method after implementation of the online payment portal?</h2>
      <p>Yes, payors can use cashier’s order or cheque for payment as provided on the PAC/Invoices.</p>
    </div>

    <div class="faq">
      <h2><span class="number">8.</span>What are the minimum and maximum transaction limits under the online payment portal for PACs/Invoices/Deposit?</h2>
      <p>The below are the respective limits:</p>
      <ul>
        <li><strong>PayNow:</strong> PayNow has a maximum daily transaction cap of $200,000, subject to the limits you have set with your bank.</li>
        <li><strong>Credit Card:</strong> subject to $10,000 limit per Payment Advice/Invoice/Deposit.</li>
      </ul>
      <strong>Note: </strong>Both locally issued, and overseas-issued credit cards (Visa and Mastercard) can be used for online payments.
    </div>

    <div class="faq">
      <h2><span class="number">9.</span>What if my deposit exceeds $200,000?</h2>
      <p>Please reach out to the Court Officer to make special arrangement for your payment. Alternatively, you can also make payment via Cashier’s Order.</p>
    </div>

    <div class="faq">
      <h2><span class="number">10.</span>What are the Court Operating Hours?</h2>
      <p><strong>Supreme Court:</strong></p>
      <ul>
        <li>Monday to Thursday: 8.30am to 1.00pm, 2.00pm to 6.00pm</li>
        <li>Friday: 8.30am to 1.00pm, 2.00pm to 5.30pm</li>
      </ul>
      <p><strong>State Courts:</strong></p>
      <ul>
        <li>Monday to Thursday: 8.30am to 1.00pm, 2.00pm to 6.00pm</li>
        <li>Friday: 8.30am to 1.00pm, 2.00pm to 5.30pm</li>
        <li>Saturday (Only Court 4A and Bail Centre): 8.30am to 1.00pm</li>
      </ul>
      <p><strong>Family Justice Courts:</strong></p>
      <ul>
        <li>Monday to Thursday: 8.30am to 1.00pm, 2.00pm to 6.00pm</li>
        <li>Friday: 8.30am to 1.00pm, 2.00pm to 5.30pm</li>
      </ul>
    </div>

    <div class="faq">
      <h2><span class="number">11.</span>Why can’t bailors use credit card for payment of bail sums?</h2>
      <p>For bails and bonds, PayNow remains the only online payment option as secured monies are required for these specific payments.</p>
      <p>Bailors can make also pay via cash, Nets, cashier’s order. For other bail payment options, please visit the Judiciary website or bail centre for more information.</p>
    </div>
    <div class="note-section">
      <strong>Note:</strong>
      <ul>
        <li>Cashier counters are only available in Supreme Court, Service Hub and State Courts, Level 4 from 1 October 2025 onwards.</li>
        <li>Within the stipulated Court Hours for payments to be paid within the due date, where applicable</li>
        <li>Available from 1 October 2025 onwards</li>
      </ul>
    </div>
  </div>
</div>
